import Nav from "./Navigation";
import Footer from "./Footer";
import HomeSection from "./HomeSection";

const Home = () => {
  
  return (
    <div>
      <Nav/>
      <HomeSection />
      <Footer />
    </div>
      
  )
}

export default Home;